import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/member",
        name: "member",
        meta: {
            title: "操作页",
        },
        component: () => import("../views/mineIndex.vue"),
        children: [
            {
                path: "mobileold",
                name: "mobileold",
                meta: {
                    title: "验证手机号",
                },
                component: () => import("../views/member/mobileold.vue"),
            },
            {
                path: "mobilenew",
                name: "mobilenew",
                meta: {
                    title: "验证新手机号",
                },
                component: () => import("../views/member/mobilenew.vue"),
            },
            {
                path: "mobileok",
                name: "mobileok",
                meta: {
                    title: "完成",
                },
                component: () => import("../views/member/mobileok.vue"),
            },
            {
                path: "passwordchange",
                name: "passwordchange",
                meta: {
                    title: "修改密码",
                },
                component: () => import("../views/member/passwordchange.vue"),
            },
            {
                path: "authenticate",
                name: "authenticate",
                meta: {
                    title: "企业认证",
                },
                component: () => import("../views/member/authenticate.vue"),
            },
            {
                path: "cauthenticate",
                name: "cauthenticate",
                meta: {
                    title: "企业认证",
                },
                component: () => import("../views/member/cauthenticate.vue"),
            },
            {
                path: "equity",
                name: "equity",
                meta: {
                    title: "企业权益",
                },
                component: () => import("../views/member/equity.vue"),
            }
        ],
    },
    {
        path: "/main",
        name: "main",
        meta: {
            title: "操作页",
        },
        component: () => import("../views/mainIndex.vue"),
        children: [{
            path: "mine",
            name: "mine",
            meta: {
                title: "用户中心",
            },
            component: () => import("../views/member/mine.vue"),
        },
        {
            path: "new",
            name: "new",
            meta: {
                title: "公告详情",
            },
            component: () => import("../views/member/new.vue"),
        },
        ],
    },
    // 数据查询
    {
        path: "/dataQuery",
        name: "dataQuery",
        meta: {
            title: "数据查询",
        },
        component: () => import("../views/index.vue"),
        children: [
            {
                path: "zsApply",
                name: "zsApply",
                meta: {
                    title: "招商申请列表",
                },
                component: () => import("../views/dataQuery/zsApply.vue"),
            },
            {
                path: "zsCollect",
                name: "zsCollect",
                meta: {
                    title: "招商收藏列表",
                },
                component: () => import("../views/dataQuery/zsCollect.vue"),
            },
            {
                path: "zsBrowse",
                name: "zsBrowse",
                meta: {
                    title: "招商浏览列表",
                },
                component: () => import("../views/dataQuery/zsBrowse.vue"),
            },
            {
                path: "zxApply",
                name: "zxApply",
                meta: {
                    title: "资讯申请列表",
                },
                component: () => import("../views/dataQuery/zxApply.vue"),
            },
            {
                path: "zxBrowse",
                name: "zxBrowse",
                meta: {
                    title: "资讯浏览记录",
                },
                component: () => import("../views/dataQuery/zxBrowse.vue"),
            },
        ],
    },
    // 信息管理
    {
        path: "/admin",
        name: "admin",
        meta: {
            title: "信息管理",
        },
        component: () => import("../views/adminIndex.vue"),
        // business 企业信息
        children: [
            {
                path: "companyMsg",
                name: "companyMsg",
                meta: {
                    title: "公司信息",
                },
                component: () => import("../views/admin/business/companyMsg.vue"),
            },
            {
                path: "companySyn",
                name: "companySyn",
                meta: {
                    title: "关于我们",
                },
                component: () => import("../views/admin/business/companySyn.vue"),
            },
            {
                path: "companySpread",
                name: "companySpread",
                meta: {
                    title: "宣传片",
                },
                component: () => import("../views/admin/business/companySpread.vue"),
            },
            {
                path: "companyHonor",
                name: "companyHonor",
                meta: {
                    title: "公司荣誉",
                },
                component: () => import("../views/admin/business/companyHonor.vue"),
            },
            {
                path: "companyProject",
                name: "companyProject",
                meta: {
                    title: "招商项目",
                },
                component: () => import("../views/admin/business/companyProject.vue"),
            },
            {
                path: "list",
                name: "list",
                meta: {
                    title: "招商项目",
                },
                component: () => import("../views/admin/components/list.vue"),
            },
            // brand 品牌管理
            {
                path: "brandPrivate",
                name: "brandPrivate",
                meta: {
                    title: "自有品牌",
                },
                component: () => import("../views/admin/brand/brandPrivate.vue"),
            },
            {
                path: "brandChoice",
                name: "brandChoice",
                meta: {
                    title: "申请品牌-选择品牌",
                },
                component: () => import("../views/admin/brand/brandChoice.vue"),
            },
            {
                path: "brandUpload",
                name: "brandUpload",
                meta: {
                    title: "申请品牌-上传资料",
                },
                component: () => import("../views/admin/brand/brandUpload.vue"),
            },
            {
                path: "brandComplete",
                name: "brandComplete",
                meta: {
                    title: "申请品牌-完成",
                },
                component: () => import("../views/admin/brand/brandComplete.vue"),
            },
            {
                path: "brandAgent",
                name: "brandAgent",
                meta: {
                    title: "代理品牌",
                },
                component: () => import("../views/admin/brand/brandAgent.vue"),
            },
            {
                path: "brandChoices",
                name: "brandChoices",
                meta: {
                    title: "代理品牌-选择品牌",
                },
                component: () => import("../views/admin/brand/brandChoices.vue"),
            },
            {
                path: "brandUploads",
                name: "brandUploads",
                meta: {
                    title: "代理品牌-上传资料",
                },
                component: () => import("../views/admin/brand/brandUploads.vue"),
            },
            {
                path: "brandCompletes",
                name: "brandCompletes",
                meta: {
                    title: "代理品牌-完成",
                },
                component: () => import("../views/admin/brand/brandCompletes.vue"),
            },
            {
                path: "brandSale",
                name: "brandSale",
                meta: {
                    title: "销售品牌",
                },
                component: () => import("../views/admin/brand/brandSale.vue"),
            },
            {
                path: "brandChoicefs",
                name: "brandChoicefs",
                meta: {
                    title: "销售品牌-添加品牌",
                },
                component: () => import("../views/admin/brand/brandChoicefs.vue"),
            },
            {
                path: "brandAddNew",
                name: "brandAddNew",
                meta: {
                    title: "添加新品牌",
                },
                component: () => import("../views/admin/brand/brandAddNew.vue"),
            },
            // 资讯管理
            {
                path: "infoList",
                name: "infoList",
                meta: {
                    title: "资讯列表",
                },
                component: () => import("../views/admin/info/infoList.vue"),
            },
            {
                path: "infoEdit",
                name: "infoEdit",
                meta: {
                    title: "资讯编辑",
                },
                component: () => import("../views/admin/info/infoEdit.vue"),
            },
            // 联系人
            {
                path: "contactList",
                name: "contactList",
                meta: {
                    title: "联系人列表",
                },
                component: () => import("../views/admin/contact/contactList.vue"),
            },
            {
                path: "contactChoicse",
                name: "contactChoicse",
                meta: {
                    title: "选择联系人",
                },
                component: () => import("../views/admin/contact/contactChoicse.vue"),
            },
            // 下级机构
            {
                path: "lowerLevelList",
                name: "lowerLevelList",
                meta: {
                    title: "下级机构列表",
                },
                component: () => import("../views/admin/lowerLevel/lowerLevelList.vue"),
            },
            {
                path: "lowerLevelChoicse",
                name: "lowerLevelChoicse",
                meta: {
                    title: "下级机构选择",
                },
                component: () => import("../views/admin/lowerLevel/lowerLevelChoicse.vue"),
            },
            {
                path: "lowerLevelApply",
                name: "lowerLevelApply",
                meta: {
                    title: "下级机构申请",
                },
                component: () => import("../views/admin/lowerLevel/lowerLevelApply.vue"),
            },
            // 上级机构
            {
                path: "higherLevelChoicse",
                name: "higherLevelChoicse",
                meta: {
                    title: "上级机构选择",
                },
                component: () => import("../views/admin/higherLevel/higherLevelChoicse.vue"),
            },
            {
                path: "higherLevelApply",
                name: "higherLevelApply",
                meta: {
                    title: "上级机构申请",
                },
                component: () => import("../views/admin/higherLevel/higherLevelApply.vue"),
            },
        ],
    },
    //
    {
        path: "/file",
        name: "file",
        meta: {
            title: "链配网",
        },
        component: () => import("../views/file.vue"),
    },
    {
        path: "/",
        name: "home",
        meta: {
            title: "链配网",
        },
        component: () => import("../views/home/home.vue"),
    },
    {
        path: "/login",
        name: "login",
        meta: {
            title: "登录",
        },
        component: () => import("../views/home/login.vue"),
    },
    {
        path: "/register",
        name: "register",
        meta: {
            title: "注册",
        },
        component: () => import("../views/home/register.vue"),
    },
    {
        path: "/passback",
        name: "passback",
        meta: {
            title: "找回密码",
        },
        component: () => import("../views/home/passback.vue"),
    }
];

// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch((err) => err);
// };
const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
});

export default router;
